import React, { useEffect } from "react";
import { ReactComponent as CloseIcon } from "../../../assets/icons/modal/close.svg";
import { IPhoneOrder } from "../../../types/phoneOrder.type";
import DefaultModal from "../DefaultModal/DefaultModal";
import ViewPhoneOrderForm from "../forms/EditPhoneOrderForm/ViewPhoneOrderForm";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
  order: IPhoneOrder;
}

const EditPhoneOrderModal: React.FC<Props> = (props) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  return (
    <DefaultModal>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.upSide}>
            <div />
            <button className={styles.upSideButton} onClick={props.onClose}>
              <CloseIcon />
            </button>
          </div>
          <div className={styles.nameContainer}></div>
        </div>
        <ViewPhoneOrderForm
          order={props.order}
          onClose={props.onClose}
          onApply={props.onApply}
        />
      </div>
    </DefaultModal>
  );
};

export default EditPhoneOrderModal;
